module.exports = __webpack_public_path__ + "img/camera.835006c3.svg";